import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import { MdExitToApp } from '@react-icons/all-files/md/MdExitToApp';
import { AiOutlineUserAdd } from '@react-icons/all-files/ai/AiOutlineUserAdd';

import { logoutUser } from '../../../../../../services/authService';

import { setModalState } from '../../../../../../reducers/Modal/actions';
import { MODAL_INVITE_MEMBER } from '../../../../../../reducers/Modal/types';
import { InviteMembersModal } from '../../../../../auth/InviteMembersModal';
import { reportEvent } from '../../../../../../services/analyticsService';
import { CollaboratorsView } from '../CollaboratorsView';
import './index.scss';

export const UserPanel = () => {
  const dispatch = useDispatch();
  const { userDetails = {} } = useSelector(({ AuthReducer }) => AuthReducer);

  const handleLogout = useCallback(async () => {
    await logoutUser(
      true,
      userDetails?.defaultOrganization?.marketplacePartner,
    );
  }, []);

  return (
    <div className="user-panel-container">
      <div className="user-details-container">
        {userDetails.defaultOrganization?.members?.length > 0 && (
          <CollaboratorsView
            users={userDetails.defaultOrganization.members}
            shouldDisableClick
          />
        )}
        <h3 className="user-name">{userDetails.name}</h3>
        <span className="user-organization">
          {userDetails.defaultOrganization?.name}
        </span>
        <span className="user-email">{userDetails.email}</span>
      </div>

      <div className="buttons-container">
        <Tooltip title="Invite new members">
          <button
            className="logout-button"
            onClick={() => {
              reportEvent('invite_members', 'sidebar_btn_click');
              dispatch(setModalState(MODAL_INVITE_MEMBER, true));
            }}
            type="button"
          >
            <AiOutlineUserAdd size={16} color="#3f434a" />
          </button>
        </Tooltip>
        <Tooltip title="Sign out">
          <button
            className="logout-button"
            onClick={handleLogout}
            type="button"
          >
            <MdExitToApp size={16} color="#3f434a" />
          </button>
        </Tooltip>
      </div>
      <InviteMembersModal />
    </div>
  );
};
